export const marketPlaceItem = {
    id: 0,
    visibility: 0,
    title: '',
    publishDate: new Date(),
    expiryDate:null,
    author: '',
    location: '',
    content: '',
    amountInfo: '',
    amountType: '', 
    marketPlaceTypeId: 0,
    media: [],
    pinned: null,
    waterMark: ''
};